import React, { useEffect } from 'react'
import mixpanel from 'mixpanel-browser'
import { useUserStore } from 'src/_store/user.store'

let MIXPANEL_INITIALIZED = false

export function MixpanelProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUserStore((s) => ({ user: s.user }))
  const token = (import.meta as any).env.VITE_MIXPANEL_TOKEN ?? '4d07cdb862030bf38de0f7a1076784d9'

  useEffect(() => {
    if (typeof window === 'undefined') return
    const w = window as any
    if (!w.__MIXPANEL_INIT && token) {
      mixpanel.init(token)
      w.__MIXPANEL_INIT = true
      MIXPANEL_INITIALIZED = true
    } else if (w.__MIXPANEL_INIT) {
      MIXPANEL_INITIALIZED = true
    }
  }, [token])

  useEffect(() => {
    if (MIXPANEL_INITIALIZED && user?.id) {
      mixpanel.identify(user.id.toString())
    }
  }, [user])

  return <>{children}</>
}
